<template>
    <div class="materialList__buttons materialList__buttonGroup">
        <div class="materialList__buttonGroup materialList__buttonGroup--1">
            <button class="button view-warning" v-on:click="contactSelect">
                Nezávazně poptat materiál u prodejce
            </button>
            <button class="button view-primary-light view-logo" v-on:click="setDemandAsWorkIncluded()">
                Nezávazně poptat včetně práce
            </button>
        </div>
        <div class="clearfix"></div>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';

export default {
    name:     'CalculationControl',
    computed: {
        ...mapGetters('calculation', ['requestParameters', 'userInput', 'calculatedConstructionMaterial', 'construction'])
    },
    methods:  {
        ...mapActions('calculation', ['setDemandWithWork']),
        setDemandAsWorkIncluded() {
            this.setDemandWithWork(true);
            this.remarketingDataLayer(1);
            this.$router.push({ name: 'calculation.demandInformationIncludingWork' });
        },
        contactSelect() {
            this.remarketingDataLayer(0);
            this.$router.push({ name: 'calculation.contactSelect' });
        },
        pushRmkLayout(index) {
            this.remarketingDataLayer(index);
        },
        remarketingDataLayer(index) {
            const data = [
                { section: 'Nezávazně poptat materiál u prodejce' },
                { section: 'Nezávazně poptat včetně práce' },
                { section: 'Soupis materiálu' },
                { section: 'Technický list' },
            ];

            const products = this.calculatedConstructionMaterial.map((construction) => {
                return construction.products.map(({ consumption, id, name }) => {
                    return {
                        quantity: consumption, id, name, section: construction.name
                    };
                })
            }).flat();
            dataLayer.push({
                'event':         'calculator_step_3',
                'step':          3,
                'section':       this.construction.id,
                'interaction':   data[index].section,
                'area':          this.userInput.meters,
                'waste':         this.userInput.cut,
                'ecommerce':     {
                    'checkout': {
                        'actionField': { 'step': 3, 'option': data[index].section },
                        'products':    products,
                    }
                },
                'eventCallback': function () {
                }
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/calculation/calculator/construction/control/CalculationControl.vue